import React, { useState } from 'react';
import ModalComponent from '../components/Popup/Modal';

export const useModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  const show = () => setIsVisible(true);
  const hide = () => setIsVisible(false);

  const RenderModal = ({
    children,
    width,
    handleOk
  }: {
    children: React.ReactChild;
    width: number;
    handleOk: () => void;
  }) => (
    <React.Fragment>
      {isVisible && (
        <ModalComponent
          width={width}
          isVisible={isVisible}
          closeModal={hide}
          handleOk={handleOk}
        >
          {children}
        </ModalComponent>
      )}
    </React.Fragment>
  );
  return {
    show,
    hide,
    RenderModal
  };
};
